module.exports = __webpack_public_path__ + "media/images/img-pb-complete-6c21f35fb187161b07b2f456114bf1e2.png";